import { ImpactStat, ApproachItem, AdvisoryMember } from '../types';

export const impactStats: ImpactStat[] = [
  {
    icon: '🏫',
    label: '25+ Schools',
    description: 'Partnered across Hong Kong'
  },
  {
    icon: '👩‍🎓',
    label: '130+ HKUST Students',
    description: 'Engaged as contributors'
  },
  {
    icon: '📦',
    label: '60+ Digital Resources',
    description: 'Shared for schools and families'
  }
];

export const approachItems: ApproachItem[] = [
  {
    icon: '📚',
    title: 'AI Literacy Development',
    description: 'Offering professional development for teachers (train-the-trainer) on AI Literacy and applications of AI into classrooms.'
  },
  {
    icon: '🤝',
    title: 'Community Outreach',
    description: 'Connecting HKUST students and faculty with Hong Kong schools to build AI capacity in education.'
  },
  {
    icon: '🎓',
    title: 'Co-Design Opportunities',
    description: 'Giving university students hands-on experience solving real educational problems using AI responsibly.'
  },
  {
    icon: '📝',
    title: 'Accessible Research',
    description: 'Translating cutting-edge AI research into "teach-able" content'
  }
];

export const advisoryMembers: AdvisoryMember[] = [
  {
    title: 'PROF.',
    name: 'CHI YING TSUI',
    job: 'Professor, Division Of Integrative Systems And Design',
    image: '/images/about/Prof. Chi Ying Tsui.png'
  },
  {
    title: 'PROF.',
    name: 'QIAN ZHANG',
    job: 'Head Of ISD / Tencent Professor Of Engineering And Chair Professor Of CSE',
    image: '/images/about/Prof. Qian Zhang.png'
  },
  {
    title: 'MS.',
    name: 'ALISON CHAN',
    job: 'CEO And Co-Founder Of Solomon Learning Group',
    image: '/images/about/Alison Chan.png'
  },
  {
    title: 'MS.',
    name: 'GISA CHAN',
    job: 'Project Director Of Solomon Learning Group',
    image: '/images/about/Gisa Chan.png'
  }
];

export const teamMembers: AdvisoryMember[] = [
  {
    title: 'MS.',
    name: 'MINYAO SHI',
    job: 'Research Assistant',
    image: '/images/about/Minyao Shi.jpeg'
  },
  {
    title: 'MS.',
    name: 'KATHY NG',
    job: 'Research Assistant',
    image: '/images/about/Kathy Ng.jpeg'
  },
  {
    title: 'MS.',
    name: 'RACHEL CHEN',
    job: 'Research Assistant',
    image: '/images/about/Rachel Chen.jpeg'
  }
];

